<script>
	import {Button} from 'agnostic-svelte'
	import {navigate} from 'svelte-routing'
</script>
<div class="flex flex-column container">
<h1>An agent will be dialing soon!</h1>
<h3>You'll be recheached out in less than 24 hours about the selected plan</h3>
<Button mode="primary" style="margin-top:3em" on:click={()=>navigate("/")}>Go home</Button>
</div>